import CheckBoxOutlinedIcon from "@mui/icons-material/CheckBoxOutlined";
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { CollapsibleTable, CollapsibleTableCell } from "../../components/CollapsibleTable";
import { MainContainer } from '../../components/MainContainerComp';
import ScrollIndicatorsComp from "../../components/ScrollIndicatorsComp/ScrollIndicatorsComp";
import { IGangWorkInfoData } from './GangWorkInfoData';
import { captionStyles, footerStyles } from "./styled";

export const GangWorkInfo = ({ data }: { data: IGangWorkInfoData }) => {
  type ContentType = number | string | JSX.Element | null;
  const redCheckBox = <CheckBoxOutlinedIcon sx={{ color: '#C00000' }} />;
  const CenteredCellWrapper = ({ children }: { children: ContentType }) => <Box sx={{ textAlign: "center" }}>{children}</Box>

  const workInfo = data.currentGangWork.map(gw => {
    return {
      barnNumber: <CenteredCellWrapper>{gw.barnNumber}</CenteredCellWrapper>,
      nightSheet: <CenteredCellWrapper>{gw.nightSheet ? redCheckBox : ''}</CenteredCellWrapper>,
      gangNumber: <CenteredCellWrapper>{gw.gangNumber}</CenteredCellWrapper>,
      shipName: gw.shipName,
      location: gw.location,
      shiftStartTime: <CenteredCellWrapper>{gw.shiftStartTime}</CenteredCellWrapper>,
      orderedBack: <CenteredCellWrapper>{gw.orderedBack ? redCheckBox : ''}</CenteredCellWrapper>,
      offAtMidnight: <CenteredCellWrapper>{gw.offAtMidnight ? redCheckBox : ''}</CenteredCellWrapper>,
      logs: <CenteredCellWrapper>{gw.logs ? redCheckBox : ''}</CenteredCellWrapper>,
      gangHours: <CenteredCellWrapper>{gw.gangHours.toFixed(2)}</CenteredCellWrapper>,
    }
  });

  const cols: CollapsibleTableCell[] = [
    'Barn',
    'Night',
    'No.',
    'Ship Name',
    'Location',
    'Shift',
    'CB',
    'Mid.',
    'Logs',
    'Hours'
  ].map(title => ({ title, align: "center" }));

  return (
    <MainContainer hasGreyBg>
      <Typography data-automation="last-update-text" sx={captionStyles}>Last Update: {data.lastUpdate} </Typography>
      <Typography 
        component={'div'} 
        variant='container' 
        data-automation="data-container"
      >
        <ScrollIndicatorsComp>
          <CollapsibleTable
            cols={cols}
            rows={workInfo}
            isOneLevel
            dataAutomation={{ header: 'table-header', columns: [], tBody: 'table-body' }}
          />
          <Typography data-automation="next-on-night" sx={footerStyles}>Next on Night: {data.nextOnNights}</Typography>
        </ScrollIndicatorsComp>
      </Typography>
    </MainContainer>
  )
}